module.exports = {
	"numbers": [
		"first",
		"second",
		"third",
		"fourth",
		"fifth",
		"sixth",
		"seventh",
		"eighth",
		"ninth",
		"tenths"
	]
};


//////////////////
// WEBPACK FOOTER
// ./App/Service/Bpmn2Speech/abbreviations.json
// module id = 321
// module chunks = 0